import { apiClient } from './client';

export interface CasinoBalance {
  found: boolean;
  balance: number;
  currency: string;
}

export interface CasinoOpResult {
  success: boolean;
  amount?: number;
  balanceBefore?: number;
  balanceAfter?: number;
  message?: string;
}

export interface CasinoGiftResult {
  ok: boolean;
  message?: string;
}

export const casinoApi = {
  getBalance: async (clientId: string): Promise<CasinoBalance> => {
    const { data } = await apiClient.get<CasinoBalance>('/chat/casino/balance', { params: { clientId } });
    return data;
  },
  deposit: async (clientId: string, amount: number): Promise<CasinoOpResult> => {
    const { data } = await apiClient.post<CasinoOpResult>('/chat/casino/deposit', { clientId, amount });
    return data;
  },
  withdraw: async (clientId: string, amount: number): Promise<CasinoOpResult> => {
    const { data } = await apiClient.post<CasinoOpResult>('/chat/casino/withdraw', { clientId, amount });
    return data;
  },
  /**
   * `idempotencyKey`: generada por el caller UNA vez al abrir el diálogo de
   * regalo (crypto.randomUUID()) — un retry/doble-click debe reusar la MISMA
   * key para que el backend dedupe (ver CasinoService.grantBonus).
   */
  gift: async (clientId: string, amount: number, idempotencyKey: string): Promise<CasinoGiftResult> => {
    const { data } = await apiClient.post<CasinoGiftResult>('/chat/casino/gift', { clientId, amount, idempotencyKey });
    return data;
  },
  register: async (clientId: string): Promise<{ ok: boolean; created?: boolean; linked?: boolean; casinoExternalId?: string; error?: string }> => {
    const { data } = await apiClient.post('/chat/casino/register', { clientId });
    return data;
  },
};
